import AccountAddress from "@/common-components-src/js/address/accountAddress/index";
import styles from "./index.module.scss";
import { Helmet } from "react-helmet";

const ShippingAddress = () => {
  return (
    <div className={styles.box}>
      <Helmet>
        <title>My Address | Joybuy</title>
        <meta
          name="description"
          content="Joybuy offers the best online shopping experience with fast shipping and delivery guarantee on all orders. Shop now for unbeatable deals on top-quality products."
        />
      </Helmet>
      <AccountAddress isPersonModal={true} />
    </div>
  );
};
export default ShippingAddress;
